export default __webpack_public_path__ + "static/media/section1-header.7ae1dba0.png";